import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    entitySchool: {
      width: '100%',
    },
    containerDescription: {
      // justifyContent: 'flex-end',
    },
    griditemDescription: {
      marginRight: theme.spacing(2),
      display: 'inline-flex',
      alignItems: 'center',
    },
    descriptionTitle: {
      display: 'flex',
      flexDirection: 'column',
      '& .titlePrincipal': {
        fontSize: 18,
        fontWeight: 600,
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.85)',
      },
    },
    descriptionSeparator: {
      padding: '0 10px',
    },
    descriptionValue: {
      fontSize: 13,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      color: 'rgba(0, 0, 0, 0.85)',
    },
    btnAction: {
      textTransform: 'none',
      fontSize: 13,
      fontWeight: 500,
      padding: '6px 15px',
    },
    tableSchool: {
      width: '100%',
      '& > div': {
        marginTop: 0,
      },
      '& .MuiContainer-root': {
        padding: '0 !important',
      },
    },
  }),
);

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const styleSchoolTitle = () =>
  createStyles({
    titleContainer: {
      display: 'inline-flex',
      alignItems: 'center',
      '& h3': {
        fontSize: 18,
        fontWeight: 600,
        color: 'rgba(0, 0, 0, 0.85)',
        margin: '0 12px 0 0',
      },
      '& span': {
        fontSize: 13,
        color: 'rgba(0, 0, 0, 0.85)',
      },
    },
  });
